import { makeStyles, MenuItem } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useGeneral } from '../../Context/GeneralContext';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export default function SelecTCelda(flag) {
    const { celdas, setCelda, celda } = useGeneral();
    const classes = useStyles();

    // Verificar si el valor actual está en las opciones disponibles
    const availableValues = celdas.map(item => item.celda1);
    const isValidValue = celdas.length > 0 && availableValues.includes(celda);
    const selectValue = isValidValue ? celda : '';

    // Si el valor no es válido y hay celdas disponibles, seleccionar la primera
    useEffect(() => {
        if (celdas.length > 0 && !availableValues.includes(celda)) {
            setCelda(celdas[0].celda1);
        }
    }, [celdas, celda, availableValues, setCelda]);

    return (
        <div className={`infoCeldasViewHeadSelecCelda${flag.flag}`}>
            <FormControl className={classes.formControl}>
                <InputLabel htmlFor="celda">Seleccione una celda</InputLabel>
                <Select value={selectValue} onChange={(even) => setCelda(even.target.value)}>
                    {celdas.map((item, index) => (
                        <MenuItem value={item.celda1} id={index} key={item.celda1 || index}>
                            {item.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
